import _ from 'lodash';

import { formatDecimal } from 'Common/FormHelper';
import { DailyDepositFieldEnum } from 'Common/FieldEnum';

import { SiteFieldEnum } from '../../helpers/DailyDepositHelpers';
import * as types from './types';

const INITIAL_STATE = {
  primarySites: [],
  data: null,
  mealSummaries: [],
  fetching: false,
  fetchError: null,
  fetchingStack: [],
  CEPErrors: null,
  warnings: null,
  report: null,
  saveSuccessful: false,
  closeSuccessful: false,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.DAILY_DEPOSIT_SET_SAVE_SUCCESSFUL:
      return {
        ...state,
        saveSuccessful: payload,
      };
    case types.DAILY_DEPOSIT_SET_CLOSE_SUCCESSFUL:
      return {
        ...state,
        closeSuccessful: payload,
      };
    case types.DAILY_DEPOSIT_SAVE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          [DailyDepositFieldEnum.DailyDepositId]:
            payload[DailyDepositFieldEnum.DailyDepositId],
        },
      };
    case types.DAILY_DEPOSIT_CLEAR_STATE:
      return { ...INITIAL_STATE };

    case types.DAILY_DEPOSIT_GET_DATA:
      var formattedData = _.cloneDeep(payload);
      formattedData[DailyDepositFieldEnum.Sites].forEach(
        site =>
          (site[SiteFieldEnum.AttendanceFactor] = formatDecimal(2)(
            site[SiteFieldEnum.AttendanceFactor]
          ))
      );
      const fields = [
        DailyDepositFieldEnum.Misc1,
        DailyDepositFieldEnum.Misc2,
        DailyDepositFieldEnum.LaborHours,
        DailyDepositFieldEnum.Deposit,
      ];

      fields.forEach(
        field => (formattedData[field] = formatDecimal(2)(formattedData[field]))
      );

      return { ...state, data: formattedData };

    case types.DAILY_DEPOSIT_GET_WARNINGS:
      return {
        ...state,
        warnings: payload.warnings,
        CEPErrors: payload.CEPErrors,
      };
    case types.DAILY_DEPOSIT_GET_REPORT:
      return { ...state, report: payload };
    case types.DAILY_DEPOSIT_GET_SITES:
      return { ...state, primarySites: payload };
    case types.DAILY_DEPOSIT_GET_SUMMARIES:
      return { ...state, mealSummaries: payload };
    case types.DAILY_DEPOSIT_FETCH_ERROR:
      return { ...state, fetchError: payload };
    case types.DAILY_DEPOSIT_FETCHING:
      let stack = state.fetchingStack;

      if (payload) {
        stack.push(true);
      } else {
        stack.pop();
      }

      return {
        ...state,
        fetching: stack.length > 0,
        fetchingStack: stack,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/dailydeposit/state/dailydeposit/reducer.js